<script>
import API from "src/core/Api";
import {mapGetters} from "vuex";

import FrontBody from "/src/assets/Images/FrontBody.jpg";
import BackBody from "/src/assets/Images/BackBody.jpg";
import SkeletonFront from "/src/assets/Images/skfront.jpg";
import SkeletonBack from "/src/assets/Images/skback.jpg";
import Posture1 from "/src/assets/Images/posture1.jpg";
import Posture2 from "/src/assets/Images/posture2.jpg";
import Posture3 from "/src/assets/Images/posture3.jpg";
import Posture4 from "/src/assets/Images/posture4.jpg";
import Posture5 from "/src/assets/Images/posture5.jpg";
import Posture6 from "/src/assets/Images/posture6.jpg";
import Hand from "/src/assets/Images/hand.jpg";
import CustomTooltip from "./CustomTooltip.vue";

export default {
  data() {
    return {
      images: {
        front: FrontBody,
        back: BackBody,
        skeleton_front: SkeletonFront,
        skeleton_back: SkeletonBack,
        posture1: Posture1,
        posture2: Posture2,
        posture3: Posture3,
        posture4: Posture4,
        posture5: Posture5,
        posture6: Posture6,
        hand: Hand
      },
      showInput: false,
      inputText: '',
      inputPosition: { x: 0, y: 0 },
      currentImage: 'front', // default view
      body_selections: {
        front: [],
        back: [],
        skeleton_front: [],
        skeleton_back: [],
        posture1: [],
        posture2: [],
        posture3: [],
        posture4: [],
        posture5: [],
        posture6: [],
        hand: []
      },
      viewOptions: [
        { value: 'front', label: 'Cuerpo Frontal' },
        { value: 'back', label: 'Cuerpo Posterior' },
        { value: 'skeleton_front', label: 'Esqueleto Frontal' },
        { value: 'skeleton_back', label: 'Esqueleto Posterior' },
        { value: 'posture1', label: 'Posicion Neutral' },
        { value: 'posture2', label: 'Lordosis' },
        { value: 'posture3', label: 'Kyphosis' },
        { value: 'posture4', label: 'Flat Back' },
        { value: 'posture5', label: 'Sway Back' },
        { value: 'posture6', label: 'Scoliosis' },
        { value: 'hand', label: 'Mano' }
      ]
    };
  },
  components: {
    CustomTooltip
  },
  computed: {
    ...mapGetters({
      GetMedicoFichaActive: 'GetMedicoFichaActive',
    })
  },
  watch: {
    currentImage() {
      this.loadBodyParts();
    }
  },
  mounted() {
    this.ensureAllBodyPartSlugs();
    this.loadBodyParts();
  },
  methods: {
    handleClick(event) {
      const rect = event.target.getBoundingClientRect();
      this.inputPosition = {
        x: event.clientX - rect.left - 10,
        y: event.clientY - rect.top - 10,
      };
      this.showInput = true;
    },
    addLabel() {
      if (this.inputText.trim()) {
        let muscle = {
          id: 0,
          text: this.inputText,
          x: this.inputPosition.x,
          y: this.inputPosition.y
        }
        this.body_selections[this.currentImage].push(muscle);
        this.inputText = '';
        this.showInput = false;
        this.saveBodySelections(muscle, this.currentImage);
      }
    },
    hideInput() {
      this.showInput = false;
      this.inputText = '';
    },
    saveBodySelections(muscle, slug) {
      const self = this;
      API.send('POST', 'orders/metadata/save/', {
        orderId: self.GetMedicoFichaActive.orden.id,
        metadataId: muscle.id,
        slug,
        detail: muscle,
      }, function (response) {
        API.showSuccessAlert(response.msg);
        self.emitter.emit("medico-ficha-refresh", [
        'front',
        'back',
        'skeleton_front',
        'skeleton_back', 
        'posture1',      
        'posture2',      
        'posture3',      
        'posture4',      
        'posture5',      
        'posture6',      
        'hand'
        ]);
      },
        function (response) {
          API.showErrorAlert(response.msg);
        });
    },
    loadBodyParts() {
      const self = this;
      // Reset all
      Object.keys(self.body_selections).forEach(key => {
        self.body_selections[key] = [];
      });
      const meta = self.GetMedicoFichaActive.metadata;
      // Solo cargar los slugs que existen en la metadata
      Object.keys(self.body_selections).forEach(selKey => {
        if (typeof meta[selKey] !== "undefined") {
          Object.keys(meta[selKey]).forEach(function (key) {
            let itemTemp = {
              id: key,
              text: meta[selKey][key].detail.text,
              x: meta[selKey][key].detail.x,
              y: meta[selKey][key].detail.y
            }
            self.body_selections[selKey].push(itemTemp)
          });
        }
      });
    },
    deleteBodyPart(slug, id) {
      const self = this;
      API.showConfirm('¿Está seguro de eliminar?', '', function () {
        API.send('POST', 'orders/metadata/delete', {
          metadataId: id,
        }, function (response) {
          API.showSuccessAlert(response.msg);
          self.emitter.emit("medico-ficha-refresh",[
          'front',
          'back',
          'skeleton_front',
          'skeleton_back', 
          'posture1',      
          'posture2',      
          'posture3',      
          'posture4',      
          'posture5',      
          'posture6',      
          'hand'
          ]);
        },
          function (response) {
            API.showErrorAlert(response.msg);
          });
      })
    },
    ensureAllBodyPartSlugs() {
      // Inicializa todos los slugs de bodyparts en la metadata si no existen
      const meta = this.GetMedicoFichaActive.metadata;
      const slugs = [
        'front', 'back', 'skeleton_front', 'skeleton_back',
        'posture1', 'posture2', 'posture3', 'posture4', 'posture5', 'posture6', 'hand'
      ];
      let changed = false;
      slugs.forEach(slug => {
        if (typeof meta[slug] === 'undefined') {
          // Replace this.$set with direct assignment for Vue 3 compatibility
          meta[slug] = {};
          changed = true;
        }
      });
      if (changed) {
        // Si se agregaron slugs, actualiza la metadata en el store
        this.$store.commit('UpdateMedicoFichaMetadata', meta);
      }
    }
  }
};
</script>
 
<template>
 
    <div class="body-selector-container mb-2 d-flex justify-content-start align-items-center">
      <select v-model="currentImage" class="form-select custom-body-select w-auto">
        <option v-for="opt in viewOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
      </select>
    </div>

    <div class="mt-2 w-100 d-flex flex-column flex-md-row justify-content-center align-items-center position-relative body-image-wrapper">
      <div class="w-100 w-md-50 d-flex justify-content-center align-items-center" style="height: 680px;">
        <div class="w-auto position-relative" @click="handleClick($event)" style="height: 680px;">
          <img :src="images[currentImage]" alt="Human body parts" style="height: 680px; width: auto; max-width: 100%; object-fit: contain;">
         
            <div
            v-for="(item, index) in body_selections[currentImage]"
            :key="currentImage + index"
            :style="{ top: item.y + 'px', left: item.x + 'px' }"
            class="label"
            > 
            <i class="fa-solid fa-circle-xmark xclose" style="color: #1c1c1c;" @click.prevent.stop="deleteBodyPart(currentImage, item.id)"></i>
            <CustomTooltip :fontSz="12" :text="item.text" :direction="item.x>130 ? 'right' : 'left'">
            <i class="fa-regular fa-circle-dot" style="color: #db0606;" @click.stop></i>
            </CustomTooltip>
          </div>
        </div>
      </div>
     
      <div v-if="showInput" class="order-search" id="modal-cita" tabindex="-1" aria-labelledby="modal-cita-titulo" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-sm">
                <div class="modal-content">
                    <div class="modal-body">
                      <div class="row">
                        <div class="form-group col-12 d-flex flex-column justify-content-center align-items-center">
                          <label>Agregar descripción</label>
                          <input type="text" class="form-control" v-model="inputText" @keyup.enter="addLabel" />
                        </div>
                      </div>                   
                          <div class="row">
                            <div class="col-12 d-flex justify-content-center align-items-center">
                              <div type="button" @click.prevent="addLabel" class="btn btn-success m-1">Agregar</div>
                              <div type="button" @click.prevent="hideInput" class="btn btn-danger m-1">Cancelar</div>
                            </div>
                          </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </template>
 
<style scoped>
.position-relative {
  position: relative;
}

.label {
  position: absolute;
  font-size: 20px;
}

.label i{
    z-index: 1;
    transition: 0.3s;
    opacity:0.7;
}

.label:hover i,
.xclose{
    opacity:1;
    transform: scale(1.2);
    visibility: visible;
}

.xclose{
  position: absolute;
  top:0px;
  left:50%;
  font-size: 8px;
  visibility: hidden;
  transition: 0.3s;
  z-index: 1;
}

.input-container {
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.inputBodyPart{
 width: 250px;
 height: 150px;
 border-radius: 7px;
 background-color: white;
 box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
 display: flex;
 justify-content: center;
 align-items: center;
}

input {
  width: 200px;
  padding: 4px;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.popover.show {
  display: block; /* Force popover to always be visible */
}

.custom-body-select {
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  font-size: 1rem;
  color: #495057;
  box-shadow: 0 1px 2px rgba(60,60,60,0.03);
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  max-width: 260px;
}
.custom-body-select:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);
}
.custom-body-select option {
  color: #212529;
}
</style>